import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUsers,
  FaCalendarCheck,
  FaClock,
  FaRupeeSign,
  FaReceipt,
  FaChartBar,
  FaBuilding,
  FaLayerGroup,
  FaShieldAlt,
  FaChartPie,
} from "react-icons/fa";
import "./Successcard.css";

const features = [
  {
    title: "Attendance Management",
    description:
      "Track check-ins/outs with biometric, mobile or web. Real-time attendance and smart rules.",
    icon: FaCalendarAlt,
    color: "blue",
  },
  {
    title: "Employee Management",
    description:
      "Manage employee data, documents, departments, designations and more.",
    icon: FaUsers,
    color: "green",
  },
  {
    title: "Leave & Holidays",
    description:
      "Configurable leave policies, holiday calendars and approval workflows.",
    icon: FaCalendarCheck,
    color: "purple",
  },
  {
    title: "Shift Scheduling",
    description:
      "Create flexible shift rosters, manage rotations and handle night shifts easily.",
    icon: FaClock,
    color: "blue",
  },
  {
    title: "Payroll Management",
    description:
      "Automate payroll, generate payslips, manage deductions and compliance.",
    icon: FaRupeeSign,
    color: "green",
  },
  {
    title: "Expense Claims",
    description:
      "Employees can submit and track expense claims with approvals.",
    icon: FaReceipt,
    color: "cyan",
  },
  {
    title: "Reports & Analytics",
    description:
      "Get detailed reports on attendance, leave, payroll, and workforce trends.",
    icon: FaChartBar,
    color: "purple",
  },
  {
    title: "Multi-branch / Multi-firm",
    description:
      "Manage multiple companies, branches and locations from one platform.",
    icon: FaBuilding,
    color: "orange",
  },
];

const firmBenefits = [
  {
    title: "Centralized Control",
    description:
      "Manage multiple firms, branches and locations from a single login with complete visibility.",
    icon: FaLayerGroup,
    color: "purple",
  },
  {
    title: "Separate Workspaces",
    description:
      "Each company gets its own workspace with custom policies, roles and configurations.",
    icon: FaBuilding,
    color: "blue",
  },
  {
    title: "Role-Based Access",
    description:
      "Define roles and permissions for different teams across companies.",
    icon: FaShieldAlt,
    color: "orange",
  },
  {
    title: "Consolidated Reporting",
    description:
      "Get unified reports across all firms or drill down into individual company data.",
    icon: FaChartPie,
    color: "green",
  },
];

const Successcard = () => (
  <div id="successCard" className="billpunch-features">
    <section
      className="billpunch-features__section"
      aria-labelledby="billpunch-features-title"
    >
      <header className="billpunch-features__heading">
        <h2 id="billpunch-features-title">
          Powerful Features for Modern HR Teams
        </h2>
        <p>
          Everything you need to manage your people and processes, in one place.
        </p>
        {/* <a
          className="billpunch-features__explore"
          href="#billpunch-feature-grid"
        >
          Explore All Features <span aria-hidden="true">→</span>
        </a> */}
      </header>
      <div
        id="billpunch-feature-grid"
        className="billpunch-features__grid"
        tabIndex={-1}
      >
        {features.map(({ title, description, icon: Icon, color }) => (
          <article className="billpunch-feature" key={title}>
            <span
              className={`billpunch-feature__icon billpunch-feature__icon--${color}`}
            >
              <Icon aria-hidden="true" />
            </span>
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>
    </section>
    <section
      className="billpunch-firms"
      aria-labelledby="billpunch-firms-title"
    >
      <div className="billpunch-firms__inner">
        <div className="billpunch-firms__copy">
          <span className="billpunch-firms__label">
            Built for Growing Businesses
          </span>
          <h2 id="billpunch-firms-title">
            Why BillPunch is Ideal
            <br />
            for Multiple Firms?
          </h2>
          <p>
            Whether you're managing 2 companies or 20, BillPunch gives you the
            flexibility and control to handle all your workforce operations
            seamlessly.
          </p>
          <Link className="billpunch-firms__button" to="/contact_us">
            Book a Demo <span aria-hidden="true">→</span>
          </Link>
        </div>
        <div className="billpunch-firms__grid">
          {firmBenefits.map(({ title, description, icon: Icon, color }) => (
            <article
              className={`billpunch-firm-benefit billpunch-firm-benefit--${color}`}
              key={title}
            >
              <span
                className={`billpunch-feature__icon billpunch-feature__icon--${color}`}
              >
                <Icon aria-hidden="true" />
              </span>
              <div>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Successcard;
